import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FaceIconBrandLarge from "@/theme/icons/FaceIconBrandLarge";
import IconLoader from "@/features/Common/components/IconLoader";

interface UserCreatedScreenProps {
  onContinue: () => void;
  generatedUserId: string | null;
}

export default function UserCreatedScreen({
  onContinue,
  generatedUserId,
}: UserCreatedScreenProps) {
  const { t } = useTranslation();

  return (
    <Stack
      p={2}
      spacing={4}
      justifyContent="flex-end"
      sx={{ flex: "1 1 auto" }}
    >
      <FaceIconBrandLarge />

      <Typography variant="h3">
        {t("PublicBinahScanFlow.userCreated.title")}
      </Typography>

      {generatedUserId && (
        <Box
          role="alert"
          display="flex"
          p={2}
          flexDirection="row"
          alignItems="center"
          gap={1}
          borderRadius={3}
          bgcolor="primary.100"
        >
          <IconLoader
            icon="InformationSymbolFilledCircleIcon"
            color="primary"
          />
          <Typography fontWeight={600} fontSize={16}>
            {t("PublicBinahScanFlow.userCreated.body")} {generatedUserId}
          </Typography>
        </Box>
      )}

      <Stack direction="row" spacing={1}>
        <Button fullWidth onClick={onContinue}>
          {t("common.continueButton")}
        </Button>
      </Stack>
    </Stack>
  );
}
